/* 部分机型和浏览器隐私模式不支持 localStorage / sessionStorage，这里加个包装方法 */

// not support localStorage
if (!storageAvailable('localStorage')) {
  Object.defineProperty(window, 'localStorage', { value: mockStorageApi(), writable: false })
}

// not support sessionStorage
if (!storageAvailable('sessionStorage')) {
  Object.defineProperty(window, 'sessionStorage', { value: mockStorageApi(), writable: false })
}

// 检测 storage 是否可用
function storageAvailable(type) {
  let storage
  if (!(type in window)) return false
  try {
    storage = window[type]
    if (!storage) return false
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    )
  }
}

function mockStorageApi() {
  let obj = {}
  return {
    length: Object.keys(obj).length,
    clear() {
      obj = {}
    },
    getItem(key) {
      return obj[key]
    },
    key() {
      return ''
    },
    removeItem(key) {
      delete obj[key]
    },
    setItem(key, value) {
      obj[key] = value
    }
  }
}
